
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category-politics",
      function () {
        return require("private-next-pages/category-politics/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category-politics"])
      });
    }
  